import React from 'react';
import { Star, Quote } from 'lucide-react';

const GoogleReviews = () => {
  // REAL Google Reviews from customers
  const reviews = [
    {
      id: 1,
      author: "Nicolas Pouliot",
      rating: 5,
      text: "Our ride from the hotel to the ferry port with Santorini Best Experience was great, the car was clean, thanks to our driver, George. He was courteous, super helpful, and kept us laughing with great conversation. We really enjoyed his vibe and would definitely recommend his service. We'll be booking with George again when we return to Santorini.",
      date: "3 months ago",
      avatar: "NP"
    },
    {
      id: 2,
      author: "Christina Izzo",
      rating: 5,
      text: "Our trip from the hotel to the ferry port with Santorini Best Experience was awesome, all thanks to George! He was so polite, helpful, and had us cracking up with his fun stories and chats. It made the ride such a blast! I'd totally recommend George's service to anyone visiting Santorini.",
      date: "3 months ago",
      avatar: "CI"
    },
    {
      id: 3,
      author: "Payal Pande",
      rating: 5,
      text: "George was a fantastic and knowledgeable driver. He always arrived on time, anticipated our arrival, provided insightful commentary on the island and its rich history. Would recommend anyone visiting Santorini and looking for reliable transportation to use this company!",
      date: "7 months ago",
      avatar: "PP"
    },
    {
      id: 4,
      author: "Ana Arjol",
      rating: 5,
      text: "He was very kind and punctual. There was enough time to share some very interesting secrets and anecdotes of the island. If we return to Santorini, we will definitely go with the same company again!",
      date: "4 months ago",
      avatar: "AA"
    },
    {
      id: 5,
      author: "Siobhan Goryl",
      rating: 5,
      text: "Not just a taxi driver, he was a brilliant tour guide too, giving us so much info on the way to our hotel. Thanks",
      date: "3 months ago",
      avatar: "SG"
    },
    {
      id: 6,
      author: "Julianna Hubler",
      rating: 5,
      text: "It was an amazing ride. Extremely friendly and helpful! So happy with the company",
      date: "7 months ago",
      avatar: "JH"
    }
  ];

  const totalRating = 5.0;
  const totalReviews = 10;

  return (
    <div className="bg-gradient-to-br from-zinc-900 via-zinc-800 to-zinc-900 py-16 px-4">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-12">
          <h2 className="text-3xl sm:text-4xl font-bold text-white mb-4">
            What Our Customers Say
          </h2>
          <p className="text-zinc-400 text-lg mb-6">
            Trusted by travelers from around the world
          </p>
          
          {/* Google Rating Summary */}
          <div className="flex items-center justify-center gap-4 mb-4">
            <div className="flex items-center gap-2">
              <img 
                src="https://www.google.com/images/branding/googlelogo/2x/googlelogo_color_92x30dp.png" 
                alt="Google"
                className="h-6"
              />
              <span className="text-white font-semibold text-2xl">{totalRating}</span>
            </div>
            <div className="flex">
              {[...Array(5)].map((_, i) => (
                <Star key={i} className="w-6 h-6 fill-amber-500 text-amber-500" />
              ))}
            </div>
            <span className="text-zinc-400">Based on {totalReviews} reviews</span>
          </div>

          {/* Trust Badges */}
          <div className="flex flex-wrap items-center justify-center gap-6 mt-8">
            <div className="flex items-center gap-2 text-amber-400">
              <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M6.267 3.455a3.066 3.066 0 001.745-.723 3.066 3.066 0 013.976 0 3.066 3.066 0 001.745.723 3.066 3.066 0 012.812 2.812c.051.643.304 1.254.723 1.745a3.066 3.066 0 010 3.976 3.066 3.066 0 00-.723 1.745 3.066 3.066 0 01-2.812 2.812 3.066 3.066 0 00-1.745.723 3.066 3.066 0 01-3.976 0 3.066 3.066 0 00-1.745-.723 3.066 3.066 0 01-2.812-2.812 3.066 3.066 0 00-.723-1.745 3.066 3.066 0 010-3.976 3.066 3.066 0 00.723-1.745 3.066 3.066 0 012.812-2.812zm7.44 5.252a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
              </svg>
              <span className="font-semibold">Verified by Google</span>
            </div>
            <div className="flex items-center gap-2 text-green-400">
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              <span className="font-semibold">100% Real Reviews</span>
            </div>
            <div className="flex items-center gap-2 text-blue-400">
              <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 20 20">
                <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
              </svg>
              <span className="font-semibold">5-Star Rated</span>
            </div>
          </div>
        </div>

        {/* Reviews Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {reviews.map((review) => (
            <div 
              key={review.id}
              className="bg-zinc-800 border border-zinc-700 rounded-xl p-6 hover:border-amber-500/50 transition-all duration-300 hover:shadow-xl hover:shadow-amber-500/10"
            >
              <div className="flex items-start justify-between mb-4">
                <div className="flex items-center gap-3">
                  {/* Avatar */}
                  <div className="w-12 h-12 rounded-full bg-gradient-to-br from-amber-500 to-amber-600 flex items-center justify-center text-white font-bold">
                    {review.avatar}
                  </div>
                  <div>
                    <h4 className="text-white font-semibold">{review.author}</h4>
                    <p className="text-zinc-500 text-sm">{review.date}</p>
                  </div>
                </div>
                {/* Google Icon */}
                <img 
                  src="https://www.google.com/favicon.ico" 
                  alt="Google"
                  className="w-5 h-5"
                />
              </div>

              {/* Rating Stars */}
              <div className="flex gap-1 mb-3">
                {[...Array(review.rating)].map((_, i) => (
                  <Star key={i} className="w-5 h-5 fill-amber-500 text-amber-500" />
                ))}
              </div>

              {/* Review Text */}
              <div className="relative">
                <Quote className="absolute -top-2 -left-2 w-8 h-8 text-amber-500/20" />
                <p className="text-zinc-300 leading-relaxed pl-6">
                  {review.text}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* CTA to Google */}
        <div className="text-center mt-12">
          <a
            href="https://www.google.com/search?q=santorini+best+experience"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 bg-amber-500 hover:bg-amber-600 text-white font-semibold px-8 py-4 rounded-lg transition-all duration-300 hover:scale-105 hover:shadow-xl hover:shadow-amber-500/20"
          >
            <img 
              src="https://www.google.com/favicon.ico" 
              alt="Google"
              className="w-5 h-5"
            />
            <span>Read All {totalReviews} Reviews on Google</span>
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
            </svg>
          </a>
          <p className="text-zinc-500 text-sm mt-4">
            Join hundreds of satisfied customers
          </p>
        </div>
      </div>
    </div>
  );
};

export default GoogleReviews;